import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const defaultButtonProps = {
  text: PropTypes.string,
  extraClass: PropTypes.string,
};

function ButtonLink({ text, href, extraClass, icon }) {
  let content;
  if (icon && !text) {
    content = <i className={`feather feather ${icon}`} />;
  } else {
    content = text;
  }
  return (
    <Link to={href} className={`${extraClass || ""}`}>
      {content}
    </Link>
  );
}

ButtonLink.propTypes = {
  ...defaultButtonProps,
  icon: PropTypes.string,
  href: PropTypes.string,
};

function LinkChildren({ children, href, extraClass }) {
  return (
    <Link to={href} className={`${extraClass || ""}`}>
      {children}
    </Link>
  );
}

LinkChildren.propTypes = {
  ...defaultButtonProps,
  href: PropTypes.string,
};

function Button({ text, extraClass, icon, onClick }) {
  let content;
  if (icon && !text) {
    content = <i className={`feather ${icon}`} />;
  } else {
    content = text;
  }
  return (
    <button className={`btn ${extraClass || ""}`} onClick={onClick}>
      {content}
    </button>
  );
}

Button.propTypes = {
  ...defaultButtonProps,
  icon: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export { ButtonLink, LinkChildren, Button };
